import { request } from "@umijs/max";

export async function fetchProductListItems(listId: any) {
  return request(`/data/fetch_product_list_items/${listId}`);
}